import { all, call, put, select, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { BASE_URL } from "../../shared/constants";
import {
  setLocationStart,
  setLocationSucess,
  setLocationError,
  setSharedLocationStart,
  setSharedLocationSucess,
  setSharedLocationError,
  searchDirectionStart,
  searchDirectionError,
  searchDirectionSuccess,
} from "./reducer";

function* searchDirection() {
  try {
    const { startLocation, endLocation } = yield select(
      (state) => state.direction
    );
    const { routing } = yield select((state) => state.auth);
    // console.log(routing)
    const filtred = endLocation.filter((location) => location.value);

    //  console.log("filtred",filtred)
    const pathUrls = yield Promise.all(
      filtred.map(async (location, idx) => {
        if (idx === 0) {
          const x1 = startLocation.coordinates[0];
          const y1 = startLocation.coordinates[1];
          const x2 = location.value.coordinates[0];
          const y2 = location.value.coordinates[1];

          const url = routing
            ? `https://ssgi.edas.et/geoserver/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:pgr_ksp_special&outputFormat=application/json&viewparams=x1:${x1};y1:${y1};x2:${x2};y2:${y2};k=2`
            : `https://ssgi.edas.et/geoserver/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:pgr_ksp&outputFormat=application/json&viewparams=x1:${x1};y1:${y1};x2:${x2};y2:${y2};k=2`;
          const {
            data: { features },
          } = await axios.get(url);

          return {
            startLocation,
            endLocation: location.value,
            data: features,
            url,
          };
        } else {
          const x1 = filtred[idx - 1].value.coordinates[0];
          const y1 = filtred[idx - 1].value.coordinates[1];
          const x2 = location.value.coordinates[0];
          const y2 = location.value.coordinates[1];

          const url = routing
            ? `https://ssgi.edas.et/geoserver/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:pgr_ksp_special&outputFormat=application/json&viewparams=x1:${x1};y1:${y1};x2:${x2};y2:${y2};k=2`
            : `https://ssgi.edas.et/geoserver/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:pgr_ksp&outputFormat=application/json&viewparams=x1:${x1};y1:${y1};x2:${x2};y2:${y2};k=2`;
          const {
            data: { features },
          } = await axios.get(url);

          return {
            startLocation: filtred[idx - 1].value,
            endLocation: location.value,
            data: features,
            url,

          };


        }
      })
    );
    //  console.log("tatat",startLocation);
    yield put(
      searchDirectionSuccess({
        pathUrls,
      })
    );
  } catch (error) {
    yield put(
      searchDirectionError({
        error,
      })
    );
  }
}
function* setLocation({ payload: { start, end } }) {
  try {
    const {
      data: { placeName: startName },
    } = yield axios.get(
      `${BASE_URL}/api/landmark/getPlaceName?coordinate=${start[0]},${start[1]}`
    );

    const {
      data: { placeName: endName },
    } = yield axios.get(
      `${BASE_URL}/api/landmark/getPlaceName?coordinate=${end[0]},${end[1]}`
    );
    // console.log("hey", startName)
    // console.log("hey", endName)
    const startLocation = {
      id: startName,
      label: startName != null ? startName : start,
      coordinates: start,
    };

    const endLocation = {
      id: endName,
      label: endName != null ? endName : end,
      coordinates: end,
    };

    yield put(
      setLocationSucess({
        startLocation,
        endLocation,
      })
    );
  } catch (error) {
    yield put(
      setLocationError({
        error,
      })
    );
  }
}

function* setSharedLocation({ payload: { query } }) {
  const pathUrls = [];
  if (query.coordinates) {
    const paths = query.coordinates.split(",");
    for (const path of paths) {
      const coordinates = path.split("|");
      if (coordinates.length === 4) {
        const x1 = parseFloat(coordinates[0]),
          y1 = parseFloat(coordinates[1]),
          x2 = parseFloat(coordinates[2]),
          y2 = parseFloat(coordinates[3]);
        pathUrls.push({
          startLocation: {
            coordinates: [x1, y1],
          },
          endLocation: {
            coordinates: [x2, y2],
          },
          url: `https://ssgi.edas.et/geoserver/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=geoserver:pgr_ksp&outputFormat=application/json&viewparams=x1:${x1};y1:${y1};x2:${x2};y2:${y2};k=3`,
        });
      }
    }
    yield put(
      setSharedLocationSucess({
        pathUrls,
      })
    );
  }
}

function* onSearchDirection() {
  yield takeLatest(
    [searchDirectionStart.type, setLocationSucess.type],
    searchDirection
  );
}

function* onSetLocation() {
  yield takeLatest(setLocationStart.type, setLocation);
}

function* onSetSharedLocation() {
  yield takeLatest(setSharedLocationStart.type, setSharedLocation);
}

function* directionSagas() {
  yield all([
    call(onSearchDirection),
    call(onSetLocation),
    call(onSetSharedLocation),
  ]);
}

export default directionSagas;
